import { useState, useEffect } from "react";
import { FaArrowCircleLeft, FaTrash, FaPlusCircle, } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { FaSearch } from "react-icons/fa";
import { showSuccess, showError, showWarning } from "../../General/Toast";
import { useMemo } from "react";
import { toast } from "react-toastify";

function Challan_Invoice({ clientData, role }) {

const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state;

  const [ReturnDate, setReturnDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [partyName, setPartyName] = useState("");
  const [partyAddress, setPartyAddress] = useState("");
  const [partyGst, setPartyGst] = useState("");
  const [partyNo, setPartyNo] = useState("");
  const [purchaseBill, setPurchaseBill] = useState([]);
  const [returnAgainst, setReturnAgainst] = useState("");
const [received, setReceived] = useState(0);
  const [due, setDue] = useState(0);
  const [unit, setunit] = useState([]);
  const [category, setCategory] = useState([]);
  const [visitParty, setVisitParty] = useState(0);
  const [originalTotalPur, setOriginalTotalPur] = useState(0);
  const [previousBalance, setPreviousBalance] = useState(0);
  const [isIGSTBill, setIsIGSTBill] = useState(false);
  const [estimateDate, setEstimateDate] = useState(
    new Date().toISOString().slice(0, 16)
  );

    const [challanDate, setChallanDate] = useState(
    new Date().toISOString().slice(0, 16)
  );

  const [estimateNo, setEstimateNo] = useState("");
  const [inventory, setInventory] = useState([]);
  const [description, setDescription] = useState("");
  const [selectedBankId, setSelectedBankId] = useState(0);
  const [bankList, setBankList] = useState([]);
  const [paidAmount, setPaidAmount] = useState(0);
  const [isFullyPaid, setIsFullyPaid] = useState(false);
  const [discountValue, setDiscountValue] = useState(0);
  const [discountTypeUI, setDiscountTypeUI] = useState("amount");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [selectedParty, setSelectedParty] = useState(null);
  const [showPartyModal, setShowPartyModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [partyList, setPartyList] = useState([]);
  const [search, setSearch] = useState("");
 const [showExitModal, setShowExitModal] = useState(false);
  const [isNewParty, setIsNewParty] = useState(false);
  const [showPartyForm, setShowPartyForm] = useState(false);
  const[shippingAdd,setShippingAdd] = useState("");
  
  const [newCust, setNewCust] = useState({
    name: '',
    first_visit: '',
    last_visit: '',
    mobile: '',
    email: "",
    total_pur: "",
    total_due: "",
    loyality: '',
    visits: "",
    gstin: '',
    gst_type: "",
    gst_state: '',
    address: '',
    history: '',
    opening_balance: '',
    opening_bal_status: '',
    balance: '',
    asOfDate: '',
    p_type: '',
    client_id: '',
    invoiceNo: '',
    payment_method: ''
  })

  const [formData, setFormData] = useState({
    payment_method: '',
    client_id: '',
    description: '',
    date: '',
    mode: '',
    cb_payid: '',
    paid: '',
    client_type: '',
    category: "",
    seller_name: "",
  });
  const isEditMode = Boolean(editData);
  const currId = editData?.id || 0 ;

  useEffect(() => {
    if (!editData) return;

    setSelectedParty({
      id: editData.party_id,
      name: editData.name,
      mobile: editData.mobile,
      address: editData.address,
      gstin: editData.gstin,
    });

    setInvoiceNo(editData.invoiceNo || "");
    setPartyName(editData.name || "");
    setPartyAddress(editData.address || "");
    setPartyNo(editData.mobile || "");
    setDescription(editData.description || "");
    setEstimateDate(
      editData.date || "",
    );

    setBillDiscount({
      type:
        editData.last_discount_type === "Percentage"
          ? "percent"
          : "amount",
      value: Number(editData.last_discount || 0),
    });

    const parsed =
      typeof editData.items === "string"
        ? JSON.parse(editData.items)
        : editData.items;

    const formattedRows = parsed.map((item, index) => ({
      id: index + 1,
      name: item.name,
      category: item.category,
      unit: item.unit,
      qty: Number(item.quant),
      price: Number(item.price_per_unit),
      discountType: item.dis_type || "percent",
      discountValue: Number(item.discount || 0),
      taxRate: item.taxRate || "",
      taxType: item.sale_price_withTax || "Without Tax",
      amount: Number(item.amount),
    }));

    setRows(formattedRows);

    setFormData((prev) => ({
      ...prev,
      payment_method: editData.payment_method || "",
      seller_name: editData.seller || '',
    }));

    setSelectedBankId(Number(editData.cb_payid || 0));

    setPaidAmount(Number(editData.received || 0));


  }, [editData]);




  const [billDiscount, setBillDiscount] = useState({
    type: "percent",
    value: 0,
  });

  const [rows, setRows] = useState([
    {
      id: 1,
      name: "",
      category: "",
      unit: "",
      price: "",
      qty: "",
      taxType: "Without Tax",
      taxRate: "",
      amount: "",
      discountType: "percent",
      discountValue: 0,
    },
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updated = { ...prev, [name]: value };

      return updated;
    });
  };

  const handleInputChangeCust = (e) => {
    const { name, value } = e.target;

    setNewCust(prev => {
      const updated = { ...prev, [name]: value };

      return updated;
    });
  };




  const addRow = () => {
    setRows([
      ...rows,
      {
        id: rows.length + 1,
        name: "",
        category: "",
        unit: "",
        price: "",
        qty: "",
        taxType: "Without Tax",
        taxRate: "",
        amount: "",
        discountType: "percent",
        discountValue: 0,
      },
    ]);
  };


  const handleRowChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };


  const handleSelectItem = (index, item) => {
    const updatedRows = [...rows];

    updatedRows[index] = {
      ...updatedRows[index],

      name: item.name,
      category: item.category,
      unit: item.unit,
      price: Number(item.sale_price || 0),
      tax: item.taxRate,
      qty: 1,
      amount: Number(item.sale_price || 0) * 1,
    };

    setRows(updatedRows);
  };



  // const calculateRowAmount = (row) => {
  //   const qty = Number(row.qty || 0);
  //   const price = Number(row.price || 0);

  //   let base = qty * price;

  //   // discount
  //   if (row.discountValue) {
  //     if (row.discountType === "percent") {
  //       base -= (base * row.discountValue) / 100;
  //     } else {
  //       base -= Number(row.discountValue);
  //     }
  //   }

  //   const rate =
  //     parseFloat((row.taxRate || "").replace(/[^0-9.]/g, "")) || 0;


  //   if (row.taxType === "Without Tax") {
  //     base += (base * rate) / 100;
  //   }

  //   return base;
  // };
const calculateRowAmount = (row) => {
  const qty = Number(row.qty || 0);
  const price = Number(row.price || 0);

  let base = qty * price;

  // Discount
  if (row.discountValue) {
    if (row.discountType === "percent") {
      base -= (base * Number(row.discountValue)) / 100;
    } else {
      base -= Number(row.discountValue);
    }
  }

  // Tax Rate (works for both "18%" and 18)
  const rate =
    parseFloat(String(row.taxRate || "").replace(/[^0-9.]/g, "")) || 0;

  if (row.taxType === "Without Tax") {
    base += (base * rate) / 100;
  }

  return base;
};

  const totalQty = rows.reduce(
    (sum, row) => sum + Number(row.qty || 0),
    0
  );




  const returnAmount = rows.reduce(
    (sum, row) => sum + Number(row.amount || 0),
    0
  );

  const subTotal = useMemo(() => {
    return rows.reduce((sum, row) => {
      return sum + calculateRowAmount(row);
    }, 0);
  }, [rows]);



  // let discountedTotal = subTotal;

  const discountedTotal = useMemo(() => {
    let total = subTotal;

    if (billDiscount.value) {
      if (billDiscount.type === "percent") {
        total -= (subTotal * billDiscount.value) / 100;
      } else {
        total -= Number(billDiscount.value);
      }
    }

    return Math.max(0, total);
  }, [subTotal, billDiscount]);


  const calculateGST = (rows) => {
    let sgst = 0;
    let cgst = 0;
    let igst = 0;

    rows.forEach((row) => {
      const qty = Number(row.qty || 0);
      const price = Number(row.price || 0);

      let base = qty * price;

      if (row.discountValue) {
        if (row.discountType === "percent") {
          base -= (base * row.discountValue) / 100;
        } else {
          base -= Number(row.discountValue);
        }
      }

      const rate =
        parseFloat((row.taxRate || "").replace(/[^0-9.]/g, "")) || 0;

      const taxAmount = (base * rate) / 100;

      if (!row.taxRate) return;

      if (row.taxRate.startsWith("GST")) {
        sgst += taxAmount / 2;
        cgst += taxAmount / 2;
      } else if (row.taxRate.startsWith("IGST")) {
        igst += taxAmount;
      }
    });

    return {
      sgst,
      cgst,
      igst,
      totalTax: sgst + cgst + igst,
    };
  };

  const buildItemsPayload = () => {
    return rows.map((row, index) => {
      const qty = Number(row.qty || 0);
      const price = Number(row.price || 0);

      const base = qty * price;

      // discount
      let discountAmount = 0;
      if (row.discountType === "percent") {
        discountAmount = (base * Number(row.discountValue || 0)) / 100;
      } else {
        discountAmount = Number(row.discountValue || 0);
      }

      const afterDiscount = base - discountAmount;

      // tax
      const taxRate = parseFloat(
        (row.taxRate || "").replace(/[^0-9.]/g, "")
      ) || 0;

      const taxAmount =
        row.taxType === "Without Tax"
          ? (afterDiscount * taxRate) / 100
          : 0;

      const finalAmount = afterDiscount + taxAmount;

      // const totalMRP = qty * mrp;

      return {
        id: row.id || null,
        SNo: index + 1,
        name: row.name,
        quant: qty,
        unit: row.unit,
        price_per_unit: price,
        discount: row.discountValue || 0,
        dis_type: row.discountType,
        taxRate: row.taxRate || "None",
        taxAmount: Number(taxAmount.toFixed(2)),
        amount: Number(finalAmount.toFixed(2)),

        category: row.category || "",
        pur_price: row.pur_price || 0,
        mrp: row.mrp || 0,
        typeOfItem: row.typeOfItem,
        sale_price_withTax: row.taxType || "Without Tax",

        stockReducer: ["", row.name, qty],
      };
    });
  };




  const handleSubmit = async () => {

    try {
    
      const payload = {
       invoiceNo: returnAgainst,
        shipping:shippingAdd,
        cust_name: selectedParty?.name,
        cust_number: selectedParty?.mobile,
        challan_date:challanDate,
        date:estimateDate,
        client_type: role,
      };

  
      const  res = await axios.post(
          `https://api.dectwinbilling.com/api/new-deleivery-challan/${clientData.id}`,
          payload
        );

        showSuccess("Delivery challan creating successfully");
      resetForm();
    } catch (err) {
      console.error(err);
      showError(
        isEditMode
          ? "Failed to update challan"
          : "Failed to save sale challan"
      );
    }
  };

  const { sgst, cgst, igst, totalTax } = useMemo(() => {
    return calculateGST(rows);
  }, [rows]);


  const resetForm = () => {
    setReturnDate(new Date().toISOString().split("T")[0]);

    // Party Details
    setSelectedParty(null);
    setPartyName("");
    setPartyAddress("");
    setPartyGst("");
    setPartyNo("");

    // Seller
    setFormData((prev) => ({
      ...prev,
      seller_name: "",
      payment_method: "",
      cb_payid: 0,
    }));

    // Bank
    setSelectedBankId(0);

    setDescription("");

    // Bill Discount
    setBillDiscount({
      type: "percent",
      value: 0,
    });

    // Payment
    setIsFullyPaid(false);
    setPaidAmount(0);
    setReceived(0);
    setDue(0);

    // Party Visit Details
    setVisitParty(0);
    setOriginalTotalPur(0);
    setPreviousBalance(0);

    // Return
    setReturnAgainst("");

    // Items
    setRows([
      {
        id: 1,
        name: "",
        category: "",
        unit: "",
        price: "",
        qty: "",
        tax: "",
        amount: "",
        taxMode: "GST",
        taxRate: 0,
        taxType: "Without Tax",
        discountType: "percent",
        discountValue: 0,
      },
    ]);
  };

  const paymentMethod = formData.payment_method || editData?.mode;

  const taxableTotal = useMemo(() => {
    return rows.reduce((sum, row) => sum + calculateRowAmount(row), 0);
  }, [rows]);

  const discountAmount = useMemo(() => {
    if (!billDiscount.value) return 0;

    if (billDiscount.type === "percent") {
      return (taxableTotal * billDiscount.value) / 100;
    }

    return billDiscount.value;
  }, [taxableTotal, billDiscount]);

  const payableAmount = Math.max(taxableTotal - discountAmount, 0);
  const paid = isFullyPaid ? payableAmount : Number(paidAmount || 0);
  const dueAmount = Math.max(payableAmount - Number(paidAmount || 0), 0);


  const getBillState = () => ({
    invoiceNo,
    estimateDate,
    formData,
    selectedParty,
    rows,
    billDiscount,
    description,
    paidAmount,
    isFullyPaid,
    selectedBankId,
    payableAmount,
  });

  const clearBill = () => {
    resetForm();
    setShowExitModal(false);
    navigate("/home");
  };



  const resetFormParty = () => {
    setNewCust({
      name: '',
      first_visit: '',
      last_visit: '',
      mobile: '',
      email: "",
      total_pur: "",
      total_due: "",
      loyality: '',
      visits: "",
      gstin: '',
      gst_type: '',
      gst_state: '',
      address: '',
      history: '',
      opening_balance: '',
      opening_bal_status: '',
      balance: '',
      asOfDate: '',
      p_type: '',
      client_id: ''
    })


    setShippingAdd("");

  }



const handleSearchPurchase = async () => {
  if (!returnAgainst) {
    showWarning("Please enter invoice number");
    return;
  }

  try {
    const response = await axios.get(
      `https://api.dectwinbilling.com/api/fetch-sale-detail/${returnAgainst}`
    );

    const data = response.data[0];



    // Party Details
    setSelectedParty({
      id: data.party_id,
      name: data.name,
      mobile: data.mobile,
      address: data.address,
      gstin: data.gstin,
    });

    setInvoiceNo(data.invoiceNo || "");
    setPartyName(data.name || "");
    setPartyAddress(data.address || "");
    setPartyNo(data.mobile || "");
    setDescription(data.description || "");
    setEstimateDate(data.date || "");

    // Bill Discount
    setBillDiscount({
      type:
        data.last_discount_type === "Percentage"
          ? "percent"
          : "amount",
      value: Number(data.last_discount || 0),
    });

    // Payment Details
    setFormData((prev) => ({
      ...prev,
      payment_method: data.payment_method || "",
      seller_name: data.seller || "",
    }));

    setSelectedBankId(Number(data.cb_payid || 0));

    setPaidAmount(Number(data.received || 0));

    // Items
    const parsedItems =
      typeof data.items === "string"
        ? JSON.parse(data.items)
        : data.items;

    const formattedRows = parsedItems.map((item, index) => ({
      id: index + 1,
      name: item.name,
      category: item.category,
      unit: item.unit,
      qty: Number(item.quant),
      price: Number(item.price_per_unit),
      discountType: item.dis_type || "percent",
      discountValue: Number(item.discount || 0),
      taxRate: item.taxRate || "",
      taxType: item.sale_price_withTax || "Without Tax",
      amount: Number(item.amount),
    }));

    setRows(formattedRows);

  } catch (error) {
    console.error(error);
    showError("Sale not found");
  }
};

  return (
     <div>
        <div className="page-wrapper">
  
          <div className="page-content">
  
  
            <div className="page-header d-flex align-items-center justify-content-start mb-3">
              <div className="d-flex align-items-center gap-2">
                <FaArrowCircleLeft
                  style={{ cursor: "pointer", fontSize: "24px" }}
                  onClick={() => navigate("/home")}
     
                />
  
                <h4 className="mb-0">Delivery Challan </h4>
              </div>
  
              <div className="d-flex gap-2 flex-wrap">
  
              </div>
            </div>
  
            <div className="container-fluid mt-3">
              <div className="row g-3">

                <div className="col-md-4">
  
                  <div
                    className=" p-4 rounded shadow-sm"
                    style={{ width: "300px", backgroundColor: 'var(--card-color)' }}
                  >
    
     <div className="mb-3 position-relative">
                     <strong>Challan Against</strong>

  <div className="input-group mt-2">
    <input
      className="form-control"
      placeholder="Enter Invoice Number"
      value={returnAgainst}
      onChange={(e) => setReturnAgainst(e.target.value)}
    />

    <button
      className="btn btn-primary"
      onClick={handleSearchPurchase}
    >
      <FaSearch />
    </button>
  </div>
  
  
                    </div>
                    {/* Estimate Date */}
                    <div className="mb-3 position-relative ">
                      <input
                        type="datetime-local"
                        className="form-control"
                        style={{ paddingLeft: "100px" }}
                        value={challanDate}
                        onChange={(e) => setChallanDate(e.target.value)}
                      />
                      <span
                        className="position-absolute top-50 start-0 translate-middle-y ms-1 fw-medium"
                        style={{ pointerEvents: "none" }}
                      >
                        Invoice Date:
                      </span>
                    </div>
  
                  </div>
                </div>
  
  
  
                <div className="col-md-4 ms-auto">
                  <div className="d-flex align-items-center mb-2">
                    <span className="me-2 flex-shrink-0 fw-medium" style={{ width: "130px" }}>
                      Customer Name:
                    </span>
  
                    <input
                      type="text"
                      placeholder="Enter Party Name"
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        outline: "none",
                        boxSizing: "border-box",
                      }}
  
                      value={isNewParty ? partyName : selectedParty?.name || ""}
                      readOnly={!isNewParty}
                      onClick={() => {
                        if (!isNewParty) {
                          setShowPartyModal(true);
                        }
                      }}
                      onChange={(e) => setPartyName(e.target.value)}

                           disabled
                    />
                  </div>
  
                  <div className="d-flex align-items-center mb-2">
                    <span className="me-2 flex-shrink-0 fw-medium" style={{ width: "130px" }}>
                      Mobile Number:
                    </span>
                    <input
                      className="form-control"
                      value={isNewParty ? partyNo : selectedParty?.mobile || ""}
                      readOnly={!isNewParty}
                      onChange={(e) => setPartyNo(e.target.value)}
                      required
                    />
                  </div>
  
                  <div className="d-flex align-items-center mb-2">
                    <span className="me-2 flex-shrink-0 fw-medium" style={{ width: "130px" }}>
                      Address:
                    </span>
                    <input
                      className="form-control"
          
                      value={isNewParty ? partyAddress : selectedParty?.address || ""}
                      readOnly={!isNewParty}
                      onChange={(e) => setPartyAddress(e.target.value)}
                    />
                  </div>
  
                  <div className="d-flex align-items-center">
                    <span className="me-2 flex-shrink-0 fw-medium" style={{ width: "130px" }}>
                      GSTIN Number:
                    </span>
                    <input
                      className="form-control"
          
                      value={isNewParty ? partyGst : selectedParty?.gstin || ""}
                      readOnly={!isNewParty}
                      onChange={(e) => setPartyGst(e.target.value)}
                    />
                  </div>
  
  
                </div>
  
              </div>
            </div>
  
            <div className="container-fluid mt-3">
              <div className="table-wrapper p-2">
  
                <table className="table table-bordered custom-table mb-0"
                  style={{ tableLayout: "fixed" }}
                >
  
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "70px" }}>SN</th>
                      <th style={{ width: "250px" }}>Item</th>
                      <th style={{ width: "90px" }}>Qty</th>
                      <th style={{ width: "140px" }}>Unit</th>
                      <th style={{ width: "140px" }}>Price/Unit</th>
                      <th style={{ width: "240px" }}>Discount</th>
                      <th style={{ width: "260px" }}>Tax</th>
                      <th style={{ width: "140px" }}>Amount</th>
                    </tr>
                  </thead>
  
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={row.id}>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <span>{index + 1}</span>
  
                        
                          </div>
                        </td>
  
                        <td>
                          <select
                            className="form-select form-select-sm"
                            style={{ width: "100%" }}
                            value={row.name}
                            onChange={(e) => {
                              const item = inventory.find(
                                (inv) => inv.name === e.target.value
                              );
  
                              if (item) {
                                handleSelectItem(index, item);
                              }
                            }}
                            disabled
                          >
                            <option value="">Select Item</option>
  
                            {inventory.map((item) => (
                              <option key={item.id} value={item.name}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </td>
  
  
  
                        <td>
                          <input
                            type="number"
                            className="form-control form-control-sm text-center"
                            value={row.qty || ""}
                            onChange={(e) => {
                              const updatedRows = [...rows];
  
                              const qty = Number(e.target.value) || 0;
                              const price = Number(updatedRows[index].price) || 0;
  
                              updatedRows[index].qty = qty;
                              setRows(updatedRows);
                            }}
                                 disabled
                          />
                        </td>
  
  
  
                        <td>
                          <select
                            className="form-select form-select-sm"
                            style={{ width: "100%" }}
                            value={row.unit || ""}
                            onChange={(e) => {
                              const updatedRows = [...rows];
                              updatedRows[index].unit = e.target.value;
                              setRows(updatedRows);
                            }}
                                 disabled
                          >
                            <option value="">Select Unit</option>
  
                            {unit.map((u) => (
                              <option
                                key={u.id}
                                value={u.cat_name}
                              >
                                {u.cat_name}
                              </option>
                            ))}
                          </select>
                        </td>
  
  
                        <td>
                          <input
                            type="number"
                            className="form-control form-control-sm text-end"
                            value={row.price || ""}
                            onChange={(e) => {
                              const updatedRows = [...rows];
  
                              const price = Number(e.target.value) || 0;
                              const qty = Number(updatedRows[index].qty) || 0;
  
                              updatedRows[index].price = price;
                              // updatedRows[index].amount = qty * price;
                              // updatedRows[index].amount = calculateRowAmount(updatedRows[index]);
                              setRows(updatedRows);
                            }}
                                 disabled
                          />
                        </td>
  
  
                        <td>
                          <div className="d-flex gap-2 align-items-center">
  
                            <select
                              className="form-select form-select-sm"
                              style={{ minWidth: "110px" }}
                              value={row.discountType}
                              onChange={(e) => {
                                const updated = [...rows];
                                updated[index].discountType = e.target.value;
  
                                // updated[index].amount = calculateRowAmount(updated[index]);
  
                                setRows(updated);
                              }}
                                   disabled
                            >
                              <option value="percent">Percent (%)</option>
                              <option value="amount">Amount (₹)</option>
                            </select>
  
                            <input
                              type="number"
                              className="form-control form-control-sm text-end"
                              value={row.discountValue || ""}
                              onChange={(e) => {
                                const updated = [...rows];
  
                                updated[index].discountValue = Number(e.target.value);
  
                                setRows(updated);
                              }}
                                   disabled
                            />
  
                          </div>
                        </td>
  
                        <td>
                          <div className="d-flex gap-2">
  
                            <select
                              className="form-select form-select-sm"
                              style={{ width: "130px" }}
                              value={row.taxType}
                              onChange={(e) => {
                                const updated = [...rows];
                                updated[index].taxType = e.target.value;
                                setRows(updated);
                              }}
                                   disabled
                            >
                              <option value="With Tax">With Tax</option>
                              <option value="Without Tax">Without Tax</option>
                            </select>
                            <select
                              className="form-select form-select-sm"
                              style={{ width: "130px" }}
                              value={row.taxRate}
                              onChange={(e) => {
                                const updated = [...rows];
  
                                const value = e.target.value;
                                updated[index].taxRate = value;
  
                                // updated[index].amount = calculateRowAmount(updated[index]);
  
                                setRows(updated);
                              }}
                                   disabled
                            >
                              <option value="">Tax Rate</option>
  
                              <option value="GST 0%">GST 0%</option>
                              <option value="IGST 0%">IGST 0%</option>
  
                              <option value="GST 0.25%">GST 0.25%</option>
                              <option value="IGST 0.25%">IGST 0.25%</option>
  
                              <option value="GST 3%">GST 3%</option>
                              <option value="IGST 3%">IGST 3%</option>
  
                              <option value="GST 5%">GST 5%</option>
                              <option value="IGST 5%">IGST 5%</option>
  
                              <option value="GST 12%">GST 12%</option>
                              <option value="IGST 12%">IGST 12%</option>
  
                              <option value="GST 18%">GST 18%</option>
                              <option value="IGST 18%">IGST 18%</option>
  
                              <option value=">GST 28%">GST 28%</option>
                              <option value="IGST 28%">IGST 28%</option>
                            </select>
  
                          </div>
                        </td>
  
  
                        <td className="fw-bold text-end text-success">
                          ₹ {calculateRowAmount(row).toFixed(2)}
                        </td>
  
                      </tr>
                    ))}
                  </tbody>
  
                </table>
  
              
  
              </div>
            </div>
  
            <div className="container-fluid mt-3">
              <div className="summary-box">
                <div className="summary-left">
                  <strong>Total</strong>
                </div>
  
                <div className="summary-right">
                  <div>{totalQty} </div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div> ₹ {totalTax.toFixed(2)}</div>
                  <div>₹ {subTotal}</div>
                </div>
              </div>
            </div>
  
     <div className="container-fluid mt-3 mb-3">
  <div className="row justify-content-end">
    <div className="col-md-4">
      <div
        style={{
          background: "#ece7e7",
          padding: "15px",
          borderRadius: "15px",
          width: "100%",
          maxWidth: "350px",
          marginLeft: "auto",
        }}
      >
     

              <h6 className="fw-bold mb-2 text-primary">Shipping Address</h6>

                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="Enter Address..."
                    value={shippingAdd}
                    onChange={(e) => setShippingAdd(e.target.value)}
                  />
      </div>
    </div>
  </div>
</div>
  
          </div>
  
          <div className="footer-bar mt-4">
            <button className="btn-clear btn btn-secondary" onClick={() => resetForm()} >Clear Bill</button>
            <button className="btn-save btn btn-success" onClick={handleSubmit} >  {isEditMode ? "Update & Print" : "Save & Print"}</button>
            <button className="btn-preview btn btn-primary" onClick={handleSubmit} >  {isEditMode ? "Update & Share" : "Preview & Share"}</button>
          </div>
  
        </div>
  
  
      </div>
  )
}

export default Challan_Invoice
